// 예약 도메인 조회 쿼리 키
const termsKeys = {
  all: ['terms'],
  lists: () => [...termsKeys.all, 'list'],
  detail: (type: string) => [...termsKeys.all, 'detail', type],
}

const reservationKeys = {
  all: ['reservation'],
  detail: (reservationId: string) => [
    ...reservationKeys.all,
    'detail',
    reservationId,
  ],
}

export const QUERY_KEYS = {
  TERMS: termsKeys,
  RESERVATION: reservationKeys,
} as const
